if (!customElements.get('age-verifier')) {
  customElements.define('age-verifier', class AgeVerifier extends HTMLElement {
    constructor() {
      super();
      this.storageItemName = 'whiskThemeAgeVerified';
      this.promoPopUp = document.getElementById('promo-popup');

      this.querySelector('[data-yes-button]').addEventListener('click', this.close.bind(this));
      this.querySelector('.shopify-challenge__button')?.addEventListener('click', this.close.bind(this));

      this.querySelector('[data-secondary-action-button]')?.addEventListener('click', this.secondaryAction.bind(this));
      this.querySelector('#Contact-age-verifier')?.addEventListener('submit', this.close.bind(this));

      const disasbleOnChallengePage = window.location.pathname === "/challenge"

      if (localStorage.getItem(this.storageItemName) === this.dataset.minimumAge || disasbleOnChallengePage) return;

      this.showModal();
    }

    showModal() {
      const modal = this;

      modal.addEventListener('transitionend', () => {
        modal.focus();
        trapFocus(modal);
      }, { once: true });

      setTimeout(() => {
        modal.removeAttribute('hidden');
        modal.classList.add('animate-in');
        document.documentElement.classList.add('age-verifier-open', 'never-show-promo-popup');
      }, 500);
    }

    storeKey() {
      const key = this.dataset.minimumAge;
      localStorage.setItem(this.storageItemName, key);
    }

    secondaryAction() {
      const elements = document.querySelectorAll('.content-box__secondary-action');

      elements.forEach(element => {
        element.classList.add('is-open');
      });
    }

    secondaryActionComplete() {
      const formEl = this.querySelector('#Contact-age-verifier');
      const closeAction = this.close;
      if (formEl) {
        const observer = new MutationObserver(function(mutations, obs) {
          const successMessage = form.querySelector('#form-submit-success');
          if (successMessage) {
            closeAction();
            // Once the required element is detected, disconnect the observer
            obs.disconnect();
          }
        });

        const config = { childList: true, subtree: true };
        observer.observe(form, config);
      }
    }

    close() {
      // Ensure promo popup is hidden so that the customer gets to content immediately without having to manage a second popup on the same page.
      if (this.promoPopUp) {
        this.promoPopUp.hideModal();
      }

      this.classList.remove('animate-in');
      document.documentElement.classList.remove('age-verifier-open');
      removeTrapFocus();
      this.setAttribute('hidden', '');

      if (!Shopify.designMode) {
        this.storeKey();
      }
    }
  });
}

// qc- adds no button hide content
document.addEventListener('DOMContentLoaded', function() {
  var buttonNo = document.querySelector('.button-no');
  var secondaryAction = document.querySelector('.content-box__secondary-action');
  var buttonYes = document.querySelector('[data-yes-button]');
  var buttonYesSecondary = document.querySelector('[data-secondary-action-button]');
  if (buttonNo) {
    buttonNo.addEventListener('click', function() {
      event.preventDefault();
      buttonYes.style.display = 'none';
      buttonNo.style.display = 'none';
      if (secondaryAction) {
        secondaryAction.style.display = 'none';
      }
      if (buttonYesSecondary) {
        buttonYesSecondary.style.display = 'none';
      }
    });
  }
});